<div class="kt-subheader__breadcrumbs">
    <a [routerLink]="['/']" class="kt-subheader__breadcrumbs-home">
        <em class="flaticon2-shelter"></em>
    </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="[profileUrl]" class="kt-subheader__breadcrumbs-link">
        My Profile </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <span>Change Password</span>
</div>